module.exports = __webpack_public_path__ + "img/noh.7ebd3816.png";